import React, { useCallback } from 'react';

interface CustomTimeInputProps {
    selectedDate: Date | null;
    setSelectedDate: (date: Date) => void;
    closeCalendar: () => void;
}

const TimeInput = (props: CustomTimeInputProps) => {
    const handleClick = useCallback((event: React.MouseEvent<HTMLDivElement>, value: number) => {
        event.preventDefault();
        event.stopPropagation();
        const parentId = event.currentTarget.parentElement?.id;
        const tempDate = props.selectedDate !== null ? new Date(props.selectedDate) : new Date();
        if (parentId === 'hour') {
            tempDate.setHours(value);
        } else if (parentId === 'minute') {
            tempDate.setMinutes(value);
            props.closeCalendar();
        }
        props.setSelectedDate(tempDate);
    }, [props.selectedDate]);

    return (
        <>
            <div id='hour' className='time-picker-list'>
                {Array.from({ length: 24 }, (_, i) => (
                    <div
                        id={`hour-${i}`}
                        onClick={(e) => handleClick(e, i)}
                        className={`${i === props.selectedDate?.getHours() ? 'time-selected' : ''} time-picker-tiem-list-item`}
                    >
                        {i.toString().padStart(2, '0')}
                    </div>
                ))}
            </div>
            <div id='minute' className='time-picker-list'>
                {Array.from({ length: 60 }, (_, i) => (
                    <div
                        id={`minute-${i}`}
                        onClick={(e) => handleClick(e, i)}
                        className={`${i === props.selectedDate?.getMinutes() ? 'time-selected' : ''} time-picker-tiem-list-item`}
                    >
                        {i.toString().padStart(2, '0')}
                    </div>
                ))}
            </div>
        </>);
};

export default TimeInput;
